//import './assets/css/material-design-iconic-font.min.css';
//import './assets/css/app.min.css';

import 'elm-csf-core/src/Csf/Core.css';
import 'elm-select-two/src/select2.css';
import 'elm-datepicker/css/elm-datepicker.css';
import 'elm-notifications/src/Csf/Notifications.css';
import 'elm-filter-sidebar/src/Csf/FilterSideBar.css';

import './Csf/Form.css';
import './Csf/Table.css';
import './Csf/Footer.css';
import './Csf/Header.css';
import './Csf/Timeline.css';
import './Csf/NodePager.css';
import './Csf/FileUploader.css';

// Customized CSS...
import './Customized/CustomDropdown.css';
import './Customized/DateTimePicker.css';
import './Customized/DateTimePickerTheme.css';
import './assets/css/emision-chie.css';

// Ports Handler...
import AlertHandler from './Csf/Alert.js'
import PagerHandler from './Csf/NodePager.js'
import PortsHandler from './assets/js/app_ports.js'
import DashboardChart from './assets/js/dashboard_chart.js'

// Images in Assets...
import user_logo from './assets/images/user-no-photo.svg'
import chie_logo from './assets/images/chie_horizontal.png'
import footer_logo from './assets/images/chie_horizontal-white_flex.png'

import { Elm } from './Main.elm';
import * as serviceWorker from './assets/js/serviceWorker';

// Get item from Cookie...
const cookie = key => {
    const regExp = new RegExp(`\\s*${key}\\s*=\\s*([^;]+)`);
    const matches = (`${document.cookie}`).match(regExp);

    return (matches) ? matches[1] : "";
}

// Initializing Elm App...
let mainAppDiv = document.getElementById('mainDiv')
const publicUrl = process.env.PUBLIC_URL || ''

fetch(`${publicUrl}/config/app.config.json`)
    .then(r => r.json())
    .catch(() => ({ maintenance: "off", dashboard: "off" }))
    .then(appConfig => {
        const elmApp = Elm.Main.init({
            node: mainAppDiv,
            flags: {
                env: process.env,
                ticket: cookie('ticket'),
                username: cookie('username'),
                assets: {
                    chie_logo,
                    user_logo,
                    footer_logo,
                    dashboard: appConfig.dashboard,
                    maintenance: appConfig.maintenance
                }
            }
        });

        AlertHandler(elmApp);
        PagerHandler(elmApp);
        PortsHandler(elmApp);
        DashboardChart(elmApp);
    })

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();